import { render, staticRenderFns } from "./ConfirmVerificationCode.vue?vue&type=template&id=0740c021&scoped=true"
import script from "./ConfirmVerificationCode.vue?vue&type=script&lang=js"
export * from "./ConfirmVerificationCode.vue?vue&type=script&lang=js"
import style0 from "./ConfirmVerificationCode.vue?vue&type=style&index=0&id=0740c021&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0740c021",
  null
  
)

export default component.exports